module.exports = __webpack_public_path__ + "static/img/14064B_01_20170509_LC.18cb63a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14064B_01_20170509_LC.png
// module id = DOHv
// module chunks = 0